import {createSelector} from "@ngrx/store";
import {appFeatureKey, AppState} from "./index";

export const message = createSelector(
  state => state[appFeatureKey],
  (state: AppState) => {
    return state.message;
  }
)
